const LS_SERVICE = {
  get: function (key) {
    var value = window.localStorage.getItem(key);
    var decoded =
      value !== "undefined" &&
      value !== undefined &&
      value !== "null" &&
      value !== null
        ? JSON.parse(value)
        : null;

    return decoded;
  },

  set: function (key, value) {
    if (value !== "") window.localStorage.setItem(key, JSON.stringify(value));
    else window.localStorage.removeItem(key);
  },

  edit: function (key, value) {
    var decoded = JSON.parse(value);

    if (decoded) {
      this.set(key, value);
    }
  },

  delete: function (key) {
    this.set(key, "");
  },

  has: function (key) {
    return window.localStorage.hasOwnProperty(key) ? true : false;
  },

  clear: function () {
    window.localStorage.clear();
  },
  login_clear: function () {
    window.localStorage.removeItem("id");
    window.localStorage.removeItem("name");
    window.localStorage.removeItem("profile");
    window.localStorage.removeItem("user_type");
    window.localStorage.removeItem("phone");
    window.localStorage.removeItem("email");
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("vendor_id");
    window.localStorage.removeItem("hotel_id");
    window.localStorage.removeItem("referral_code");
    window.localStorage.removeItem("employee_code");
  },
};

export default LS_SERVICE;
